{
  "loading": "Завантаження…",
  "placeholder": "Вибрати…"
}
